export default {
  privacy_sentence1:
    'BluePay Company Limited（以下简称“公司”）深知客户及用户（以下合称“您”）的隐私及个人信息保护的重要性。因此，公司制定了本隐私政策，旨在向您说明公司关于收集、使用及披露个人信息的指导原则，以便您能够放心使用通过BluePay应用程序（以下简称“应用程序”）提供的电子货币服务、支付服务、通过电子方式提供的汇款服务以及其他经泰国银行批准的当前及未来可能提供的服务（包括但不限于与公司提供的应用程序、网站及其他渠道使用相关的任何服务，以下合称“服务”）。',
  privacy_title1: '个人信息',
  privacy_sentence2:
    '“个人信息”是指与个人相关的信息，能够直接或间接识别该个人，但不包括已故人员的特定信息，如姓名、身份证号、地址、电话号码、金融交易记录等。',
  privacy_sentence3:
    '个人信息可能包含敏感信息，存在被不公平对待的风险（以下简称“敏感个人信息”），例如生物识别数据、宗教相关数据等',
  privacy_sentence4: '在此情况下，个人信息包括您向公司提供的任何信息、公司持有或依法从其他来源或他人处收集的信息。',
  privacy_sentence5:
    '如果公司出于本隐私政策规定范围之外的目的需要收集、使用或披露您的个人信息，公司将在收集、使用或披露您的个人信息之前或之时，告知您该等不同的特征。',
  privacy_sentence6: '通过使用服务，即视为您已阅读并理解本隐私政策，否则请您立即停止使用服务。',
  privacy_title2: '公司收集、使用或披露的个人信息类型',
  privacy_sentence7: '身份证、护照及其他由政府机构签发的证明文件信息，如身份证号码、姓名、姓氏、姓名前缀、签名等；',
  privacy_sentence8: '必要的联系信息，如可联系地址、电话号码等；',
  privacy_sentence9: '特定个人特征，如身份状态、生物识别数据、照片等；',
  privacy_sentence10: '教育及/或职业信息；',
  privacy_sentence11: '金融信息，如通过BluePay账户或其他服务进行的交易记录、信用卡信息、存款账户信息等；',
  privacy_sentence12:
    '与您的设备、系统及使用行为相关的信息，包括但不限于与网络连接相关的设备身份号码（如IP地址、MAC地址、设备ID）、广告ID、移动设备操作系统、移动网络服务提供商、位置、设备使用详情、cookies、电话簿、应用程序使用情况、技术信息、设备的型号及类型、照片、图像及相册等。',
  privacy_sentence12a: '相机权限，确保您可以使用诸如拍摄身份证照片等服务；',
  privacy_sentence12b: '上传照片权限，访问您的照片存储空间，以便您可以选择要使用的照片，例如在上传身份证件时；',
  privacy_sentence12c: '存储权限，访问您设备的存储空间，确保您可以在创建或编辑照片后保存照片；',
  privacy_sentence13:
    '除上述基本服务外，如公司出于提供额外服务的需要，或出于收集、使用、披露敏感个人信息的目的，公司将仅在法律规定的合法基础上进行处理。在此情况下，公司将在处理之前或之时，告知您需要收集、使用或披露的个人信息的目的和类型。',
  privacy_title3: '收集、使用和披露您个人信息的法律依据及处理目的',
  privacy_sentence14: '公司将在法律依据下，并按照以下目的收集、使用或披露您的个人信息：',
  privacy_sentence15: '（一）履行合同的必要性',
  privacy_sentence16: '- 审核账户注册申请；',
  privacy_sentence17: '- 提供公司最佳服务的其他必要事项；',
  privacy_sentence18: '- 提供支持服务，联系及请求信息，接受请求，接收新闻或查询服务；',
  privacy_sentence19: '- 提高服务质量和效率，方便您使用服务；',
  privacy_sentence20: '- 处理数据以提供服务；',
  privacy_sentence21: '- 通过您向公司提供的应用程序或联系方式，向您通知可能符合您利益或使您受益的服务；',
  privacy_sentence22: '- 与服务相关的其他处理，可能使您受益',
  privacy_sentence23: '（二）遵守法律义务',
  privacy_sentence24:
    '遵守公司所受制于的相关法律，包括遵守法律、法规、规则、行为准则或由主管部门或监管机构发布的指南，如泰国银行的通知、反洗钱法等。在此情况下，公司可能会将您的个人信息转移给内部/外部审计师、政府机构或其他相关法人实体。',
  privacy_sentence25: '（三）基于您的同意',
  privacy_sentence26:
    '分析或预测您的偏好或行为，包括进行研究、开发、产品改进和市场营销策略，以便向您提供经过分析和选择的产品和服务、特权、促销活动或建议；',
  privacy_sentence26a:
    '为了获取相机权限，以便您在 KYC 流程中拍摄身份证照片、录制面部视频和/或拍摄并上传您的证件及其他必要文件的照片。您可以随时通过应用程序或手机设置禁用此权限；',
  privacy_sentence26b:
    '为了访问您通过设备文件选择器上传的特定照片，并且仅将其用于与我们的业务和/或产品直接相关的用途。我们仅访问您手动选择的照片，绝不会扫描您的整个照片库。如果我们将来打算将您的照片用于其他用途，我们会再次征求您的同意。此外，我们保证，除非获得您的同意或法律要求，否则我们绝不会与任何第三方共享您的照片。要删除已上传的照片，您可以通过我们提供的联系方式与我们联系；',
  privacy_sentence26c: '为了访问您设备的存储空间，以便您在创建或编辑照片后能够保存照片；以及',
  privacy_sentence27: '公司不时获得您同意的其他合法目的，例如通过应用程序方便您使用其他服务提供商的服务。',
  privacy_sentence28: '（四）公司或其他公司的合法利益',
  privacy_sentence29: '预防犯罪和欺诈；',
  privacy_sentence30: '使安全系统和网络达到国际标准；',
  privacy_sentence31: 'BluePay账户的欺诈预防和安全管理。',
  privacy_sentence32: '（五）重大公共利益',
  privacy_sentence33: '为预防犯罪和欺诈进行身份识别/验证；',
  privacy_sentence34: '怀疑金融交易支持恐怖主义或洗钱行为。',
  privacy_sentence35:
    '除上述法律依据和目的外，公司可能会根据其他法律依据收集、使用或披露您的个人信息，例如防止或抑制对您的生命、身体或健康的危险，或为实现与准备历史文件或公共利益档案相关的目的。如果收集、使用或披露属于上述其他目的，公司将在之后通知您。',
  privacy_title4: '向第三方披露您的个人信息及从其他来源收集个人信息',
  privacy_sentence36:
    '为实现上述法律依据下的处理目的，公司可能会从以下人员处收集和/或使用、发送、转移、处理和/或披露个人信息：',
  privacy_sentence37: '对公司具有控制权或受公司控制的法人实体，包括受同一控制的其他公司；',
  privacy_sentence38:
    '公司为合同方或与公司具有法律关系的其他法人实体或个人，包括有权决定对您的个人信息采取任何行动的其他服务提供商，无论是在国内还是国外，例如外部服务提供商、云服务提供商或公司的其他业务合作伙伴。在此情况下，公司应确保这些服务提供商将按照本隐私政策和适用法律处理您的个人信息；',
  privacy_sentence39:
    '公司的审计师、外部审查员、政府机构、债权转让人以及公司为遵守法律而必须转移个人信息的任何其他个人或法人实体；',
  privacy_sentence40: '在公司合并、转让、出售其资产和/或业务（无论是全部还是部分）的情况下，业务/企业的受让人。',
  privacy_title5: '个人信息的保留期限',
  privacy_sentence41:
    '公司将在提供服务所必需的期限内保留您的个人信息，或者在您与公司之间合同或法律关系所规定的期限内保留，以实现上述目的。除非适用法律或法规要求公司遵守，或者为遵守公司内部实践、法律索赔或监管机构的要求，个人信息可能会被进一步保留一段合理且必要的期限，以满足每类个人信息的需要。',
  privacy_sentence42:
    '当超过保留期限，或者公司没有权利或没有其他法律依据允许公司处理您的个人信息时，公司将按照公司的数据销毁标准，对个人信息进行擦除、销毁或匿名化处理，使其成为无法识别数据主体的匿名数据。',
  privacy_title6: '您根据《个人数据保护法》（B.E. 2562）（以下简称“PDPA”）所享有的法律权利',
  privacy_sentence43: '作为 PDPA 所定义的数据主体，您依法享有以下权利：',
  privacy_title11: '（一）撤回同意的权利',
  privacy_sentence45: '您有权在公司持有您的个人信息期间，撤回您之前向公司提供的关于处理个人信息的同意。',
  privacy_title12: '（二）访问和获取个人信息副本的权利',
  privacy_sentence47:
    '您有权要求访问您提供给公司的个人信息，或者以可读或通常用于自动工具或设备的格式获取该个人信息的副本（如果公司提供），或者要求公司向其他数据控制者发送或转移此类个人信息（除非由于技术原因无法做到），包括要求披露未经您同意而获得的个人信息的获取情况。',
  privacy_title13: '（三）更正个人信息的权利',
  privacy_sentence49:
    '您有权要求公司在持有您的个人信息期间，更正您提供给公司的任何不准确的个人信息，或者补充任何数据。',
  privacy_title14: '（四）擦除、销毁或匿名化个人信息的权利',
  privacy_sentence51:
    '您有权要求公司将您提供给公司的个人信息擦除、销毁，或者匿名化处理，使其成为无法识别数据主体的匿名数据。',
  privacy_title15: '（五）限制使用个人信息的权利',
  privacy_sentence53: '您有权要求公司在法律规定的某些情况下，限制使用您提供给公司的个人信息。',
  privacy_title16: '（六）反对处理个人信息的权利',
  privacy_sentence55: '您有权在法律规定的某些情况下，反对公司处理您提供给公司的个人信息。',
  privacy_title17: '（七）向PDPA违规行为提出投诉的权利',
  privacy_sentence57: '如果公司（包括其员工或承包商）违反或未遵守PDPA，您有权向个人数据保护委员会提出投诉。',
  privacy_sentence58:
    '在此情况下，您可以通过电子邮件将您的请求发送至公司的数据保护办公室，以行使上述权利。公司将在PDPA规定的合理时间内，尽最大努力按照您的请求进行处理。此外，公司会通知您处理该请求可能产生的影响。然而，如果存在特定的法律依据允许公司这样做，公司有权拒绝您的任何请求。此外，根据行政成本和公司内部政策，公司保留向您收取处理您的请求所产生费用的权利。',
  privacy_title7: '安全性',
  privacy_sentence59:
    '公司深知您的个人信息的重要性。因此，公司不断改进和开发符合法律要求、与国际安全标准保持一致的个人信息安全系统。公司会尽最大努力遵守本隐私政策，并督促公司人员（包括数据处理者）遵守并尊重您的个人信息安全，他们有权访问个人信息或承担法律责任。',
  privacy_sentence59a:
    '如果公司需要将您的个人信息转移到国外，公司将遵守个人数据保护法律规定的标准。此外，公司不会将您的个人信息转移到不符合法律规定标准的国家，除非您同意公司将您的个人信息发送或转移到该目的地国家。然而，如果由于计算机间谍活动（如黑客攻击、盗窃、复制或破坏数据库、破坏个人密码或其他方法）导致您的个人信息被盗，且非公司过错，在这种情况下，公司有权免除由此行为产生的任何责任。',
  privacy_title8: '无完全法律行为能力人的个人信息',
  privacy_sentence60:
    '如果您被视为无完全法律行为能力人，包括未成年人（年龄低于20岁或非完全行为能力人）、被法院判定为限制行为能力人或无行为能力人，在收集、使用或披露您的个人信息时，公司将仅按照法律规定程序和标准进行。',
  privacy_title9: '政策的改进',
  privacy_sentence61:
    '使用公司的任何服务，即视为接受本隐私政策。公司可能会随时对本隐私政策进行修改，并通知您该修改。在通知修改后继续使用应用程序或任何服务，将被视为接受每次的修改。',
  privacy_title10: '联系方式',
  privacy_sentence62:
    '如果您对本隐私政策有任何疑问、投诉、访问请求，或希望查看公司持有的任何提供的个人信息，您可以通过以下方式联系我们：',
  privacy_sentence63: 'BluePay Company Limited',
  privacy_sentence64:
    '地址：BluePay Company Limited， 319 Chamchuri Square, 24th Floor, Room No.24072, Phaya Thai Road, Pathum Wan Sup-district, Pathum Wan District, Bangkok 10330'
}
